module.exports = __webpack_public_path__ + "img/YM-DX.2e92039f.png";